import React, { useState, useEffect } from 'react';
import { ratesService, SUPPORTED_STATES } from '../service/ratesService';
import './MetalRateStrip.css';

const MetalRateStrip = () => {
  const [ratesData, setRatesData] = useState(ratesService.getCurrentRates());
  const [selectedState, setSelectedState] = useState('IN');
  const [tickerPaused, setTickerPaused] = useState(false);


  useEffect(() => {
    const unsubscribe = ratesService.subscribe((newRates) => {
      setRatesData(newRates);
    });
    return () => unsubscribe();
  }, []);

  const handleStateChange = (e) => {
    const newState = e.target.value;
    setSelectedState(newState);
    ratesService.setState(newState);
  };

  // Build the list of ticker items
  const items = ratesData
    ? [
        ratesData.gold24k,
        ratesData.gold22k,
        ratesData.gold18k,
        ratesData.silver999,
        ratesData.silver925,
        ratesData.platinum950,
      ]
    : [
        { name: 'GOLD 24K', priceFormatted: '₹75,120', unit: '/ 10g', change: { pct: '+0.24%', positive: true, formatted: '+₹180' } },
        { name: 'GOLD 22K (916)', priceFormatted: '₹68,860', unit: '/ 10g', change: { pct: '+0.21%', positive: true, formatted: '+₹145' } },
        { name: 'GOLD 18K (750)', priceFormatted: '₹56,340', unit: '/ 10g', change: { pct: '+0.19%', positive: true, formatted: '+₹110' } },
        { name: 'SILVER 999', priceFormatted: '₹89,850', unit: '/ kg', change: { pct: '-0.12%', positive: false, formatted: '-₹110' } },
        { name: 'SILVER 925', priceFormatted: '₹831', unit: '/ 10g', change: { pct: '+0.05%', positive: true, formatted: '+₹4' } },
        { name: 'PLATINUM 950', priceFormatted: '₹32,450', unit: '/ 10g', change: { pct: '+0.32%', positive: true, formatted: '+₹105' } },
      ];

  // Duplicate items array for smooth infinite marquee looping
  const marqueeItems = [...items, ...items];

  return (
    <div className="metal-rate-strip">
      <div className="jmi-container rate-container">        {/* State Selector Dropdown */}
        <div className="rate-state-selector-wrap">
          <select 
            value={selectedState} 
            onChange={handleStateChange}
            className="rate-state-select"
            aria-label="Select state for bullion rates"
          >
            {SUPPORTED_STATES.map((st) => (
              <option key={st.stateCode} value={st.stateCode}>
                {st.stateName}
              </option>
            ))}
          </select>
        </div>

        {/* Continuous Moving Ticker Track */}
        <div 
          className="rate-scroll-viewport"
          onMouseEnter={() => setTickerPaused(true)}
          onMouseLeave={() => setTickerPaused(false)}
        >
          <div className={`rate-scroll-marquee ${tickerPaused ? 'paused' : ''}`}>
            {marqueeItems.map((item, idx) => {
              const isPos = item?.change?.positive ?? true;
              return (
                <div key={idx} className="rate-ticker-item">
                  <span className="rate-metal-name">{item.name}</span>
                  <span className="rate-price">{item.priceFormatted || item.price}</span>
                  <span className="rate-unit">{item.unit}</span>
                  <span className={`rate-change ${isPos ? 'positive' : 'negative'}`}>
                    {isPos ? '▲' : '▼'} {item?.change?.pct || '0.00%'}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

       
      </div>
    </div>
  );
};

export default MetalRateStrip;
